import React from 'react';
import {Col, Row} from 'react-bootstrap';

const SUMMARY_TILES = [
  {key: 'totalUsers', label: 'Total Users'},
  {key: 'activeUsers', label: 'Active Users'},
  {key: 'loggedInToday', label: 'Logged In Today'},
  {key: 'rolesInUse', label: 'Roles In Use'},
];

const DashboardSummaryCards = ({summary}) => (
  <Row className="dashboard-summary-row">
    {SUMMARY_TILES.map((tile) => (
      <Col key={tile.key} xs={6} md={3}>
        <div className="single-card p-a-16 dashboard-summary-card">
          <div className="dashboard-summary-label">{tile.label.toUpperCase()}</div>
          <div className="dashboard-summary-value">{(summary?.[tile.key] ?? 0).toLocaleString()}</div>
        </div>
      </Col>
    ))}
  </Row>
);

export default DashboardSummaryCards;
